import { ApiProperty } from '@nestjs/swagger';

/**
 * DTO que representa el detalle de valor declarado por contenedor
 */
export class ValorDeclaradoDetalleDto {
  @ApiProperty({ description: 'Número de contenedor' })
  nroContenedor!: string;

  @ApiProperty({ description: 'Valor declarado del contenedor' })
  valorDeclarado!: number;

  @ApiProperty({ description: 'Descripción de la carga' })
  descripcion!: string;

  @ApiProperty({ description: 'Tipo de mercancía' })
  tipoMercancia!: string;

  @ApiProperty({ description: 'Peso de la carga' })
  peso!: number;

  @ApiProperty({ description: 'Volumen de la carga' })
  volumen!: number;

  @ApiProperty({ description: 'Fecha de declaración' })
  fechaDeclaracion!: Date;
}

/**
 * DTO que representa la respuesta del cálculo de valor declarado
 * Nota: La clase LiquidacionVdValorDeclaradoResponseDto ya existe en liquidacion-vd-response.dto.ts
 */
